module.exports = __webpack_public_path__ + "static/media/lumbering12.a0c3af58.jpg";